import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { FuncionariosModalComponent } from '../modals/funcionarios-modal/funcionarios-modal.component';
import { Funcionario } from '../models/funcionario';
import { CRMHierarquiaUsuario } from '../models/crmhierarquia-usuario';
import { CarregandoService } from '../services/carregando.service';
import { CRMHierarquiaUsuarioService } from '../services/crmhierarquia-usuario.service';
import { GlobalService } from '../services/global.service';
import { NotificacaoService } from '../services/notificacao.service';
import { UtilitarioService } from '../services/utilitario.service';
import { ViaCepService } from '../services/via-cep.service';

declare const $: any;

@Component({
  selector: 'app-hierarquia-usuario',
  templateUrl: './hierarquia-usuario.component.html',
  styleUrls: ['./hierarquia-usuario.component.scss']
})
export class HierarquiaUsuarioComponent implements OnInit {
  raiz: CRMHierarquiaUsuario;
  tamanhoColunaNome;

  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private hierarquiaService: CRMHierarquiaUsuarioService,
    public dialog: MatDialog,
    private router: Router,
    private viaCepService: ViaCepService,
    private globalService: GlobalService,
    private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService
  ) { }

  ngAfterViewInit(): void {
  }

  ngOnInit() {
    this.buscarHierarquia();
  }

  buscarHierarquia() {
    this.carregandoService.mostra('buscaHierarquia');

    this.hierarquiaService.consultar().subscribe(hierarquia => {
      this.raiz = hierarquia;

      this.carregandoService.esconde('buscaHierarquia');
    }, (erro) => {
      this.carregandoService.esconde('buscaHierarquia');
      this.notificacaoService.erro(erro);
    });
  }

  salvar() {
    this.carregandoService.mostra('salvaHierarquia');

    this.hierarquiaService.salvar(this.raiz).subscribe(() => {
      this.notificacaoService.sucesso('Hierarquia salva com sucesso!!!');
      this.carregandoService.esconde('salvaHierarquia');
      this.buscarHierarquia();

    }, (erro) => {
      this.carregandoService.esconde('salvaHierarquia');
      this.notificacaoService.erro(erro);
    });
  }

  adicionarRaiz() {

    const dialogRef = this.dialog.open(FuncionariosModalComponent, {
      width: ($('body').width()).toString() + 'px',
      data: { mostrarBotoes: false, mostrarFunil: true },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: Funcionario) => {
      if (result) {
        this.raiz = {
          idFuncion: Number(result.idFuncion), nome: result.nome, superior: -1, funilPadrao: result.funilPadrao, filhos: [],
          verMesmoNivelFunil: false, nomeTimeFunil: '', verSomenteHierarquia: true
        };
      }
    });
  }

  updateAll() {
    this.buscarHierarquia();
  }

  excluirRaiz() {

    if (this.raiz.idFuncion) {

      this.carregandoService.mostra('excluirUsuario');

      this.hierarquiaService.podeExcluirUsuarioDaHierarquia(this.raiz.idFuncion).subscribe(resp => {
        this.raiz = undefined;
        this.carregandoService.esconde('excluirUsuario');
      }, (erro) => {
        this.carregandoService.esconde('excluirUsuario');
        this.notificacaoService.erro(erro);
      });
    } else {
      this.raiz = undefined;
    }

  }

}


